import type { ButtonHTMLAttributes } from 'react';
import styles from './AccentTextButton.module.css';

/** Backgroundless accent action from the Ten Four interface system. */
export function AccentTextButton({
  children, arrow = false, className = '', type = 'button', ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { arrow?: boolean }) {
  return <button {...props} type={type} className={`${styles.button} ${className}`}>
    <span>{children}</span>
    {arrow && <span className={styles.arrow} aria-hidden="true">→</span>}
  </button>;
}
